import React from 'react'
import './style.sass';

export default ({children}) => (
  <div className="box">
    {children}
  </div>
)